import { Spinner } from '@air/primitive-spinner';

import { type UseLoadMoreLogicParams, useLoadMoreLogic } from '~/components/LoadMoreSpinner/useLoadMoreLogic';

type LoadMoreSpinnerProps = {
  /** Offset of loader in container, 64 is default */
  topOffset?: number;
} & UseLoadMoreLogicParams;

/**
 * This component calls loadMore function if it becomes visible to a user
 */
const LoadMoreSpinner = ({ loadMore, isVisible, isLoading, topOffset = 64 }: LoadMoreSpinnerProps) => {
  useLoadMoreLogic({ loadMore, isVisible, isLoading });

  return (
    <div className="relative" data-testid="LOAD_MORE_SPINNER" style={{ top: topOffset }}>
      <div key={0} className="flex h-16 items-start justify-center">
        <Spinner className="size-7 text-teal-9" />
      </div>
    </div>
  );
};

export default LoadMoreSpinner;
